import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaUniversity, FaArrowRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import styles from "./Partners.module.css";
import { BaseURL, testUrl } from "../BaseData";

const Partners = () => {
    const { t, i18n } = useTranslation();
    const [partners, setPartners] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const [partnersRes, categoriesRes] = await Promise.all([
                    fetch(testUrl + "/api/partners/"),
                    fetch(testUrl + "/api/categoriespartnerships/")
                ]);
                const partnersData = await partnersRes.json();
                const categoriesData = await categoriesRes.json();
                setPartners(partnersData);
                setCategories(categoriesData);
                if (categoriesData.length > 0) {
                    setActiveCategory(categoriesData[0].id.toString());
                }
            } catch (error) {
                setError("Error fetching data");
                console.error("Error fetching data: ", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [i18n.language]);

    const filteredPartners = activeCategory === null
        ? partners
        : partners.filter(p => p.category === parseInt(activeCategory));

    const getName = (cat) => {
        const lang = i18n.language;
        if (lang === 'uz') return cat.name_uz;
        if (lang === 'ru') return cat.name_ru;
        return cat.name_en || cat.name_uz;
    };

    // Auto-scroll (vertical) only when there are enough cards to overflow.
    const shouldScroll = Array.isArray(filteredPartners) && filteredPartners.length > 4;

    const renderPartnerCard = (partner, keyPrefix) => (
        <div key={`${keyPrefix}-${partner.id}`} className={styles.facultyCard}>
            <img
                src={partner.image || "/default-image.jpg"}
                alt={partner.name}
                className={styles.facultyImage}
            />
            <div className={styles.facultyInfo}>
                <h3>{partner.name}</h3>
            </div>
            <div className={styles.viewMore}>
                <a href={partner.link_url} target="_blank" rel="noopener noreferrer">
                    {t("see_more")}
                </a>
            </div>
        </div>
    );

    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>Loading...</div>;
    if (error) return <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>{error}</div>;

    return (
        <div className={styles.mainContainer}>
            <div className={styles.container}>

                <div className={styles.section}>
                    <h3 className={styles.title}>{t("partners")}</h3>

                    <div className={styles.tabsContainer}>
                        <div className={styles.tabs}>
                            {categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    className={`${styles.tab} ${activeCategory === cat.id.toString() ? styles.active : ""}`}
                                    onClick={() => setActiveCategory(cat.id.toString())}
                                >
                                    {getName(cat)}
                                </button>
                            ))}
                        </div>
                    </div>

                    {Array.isArray(filteredPartners) && filteredPartners.length > 0 ? (
                        shouldScroll ? (
                            <div className={styles.marquee}>
                                <div
                                    key={activeCategory}
                                    className={styles.marqueeTrack}
                                    style={{ animationDuration: `${filteredPartners.length * 3}s` }}
                                >
                                    <div className={styles.facultyList}>
                                        {filteredPartners.filter(Boolean).map((p) => renderPartnerCard(p, 'a'))}
                                    </div>
                                    {/* Duplicate copy makes the vertical loop seamless */}
                                    <div className={styles.facultyList} aria-hidden="true">
                                        {filteredPartners.filter(Boolean).map((p) => renderPartnerCard(p, 'b'))}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={styles.facultyList}>
                                {filteredPartners.filter(Boolean).map((p) => renderPartnerCard(p, 'a'))}
                            </div>
                        )
                    ) : (
                        <div className={styles.noPartners}>{t("no_partners_found")}</div>
                    )}
                </div>

                {/* Departments Section */}
                {/* <div className={styles.section}>
                    <h3 className={styles.title}>{t("departments")}</h3>
                    <div className={styles.facultyList}>
                        {departments.length > 0 ? (
                            departments.filter(Boolean).map((department) => (
                                <Link
                                    key={department.id}
                                    to={`/faculty-kafedra/${department.slug}`}
                                    className={styles.facultyCard}
                                >
                                    <img
                                        src={department.faculty?.image || "/default-image.jpg"}
                                        alt={
                                            getDepartmentName(department) || t("no_name_available")
                                        }
                                        className={styles.facultyImage}
                                    />
                                    <div className={styles.facultyInfo}>
                                        <h3>{getDepartmentName(department)}</h3>
                                        <FaUniversity className={styles.icon}/>
                                    </div>
                                    <div className={styles.viewMore}>
                                        <span>{t("see_more")}</span>
                                        <FaArrowRight/>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div>{t("no_departments_found")}</div>
                        )}
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Partners;
